import { FilterValues } from "components/filters/FilterContext";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import ListTemplate from "components/ListTemplate";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import Tag from "components/Tag/Tag";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { formatMainAreaItemWithCount } from "utilities/translationUtils";
import { useLoaderData } from "react-router";

const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedTagInstruction => ({
  keyword: filter.keyword.query,
  page,
  perPage,
  cache: filterSet
});

const mapResponseToFilterValues = (
  response: server.dto.ListTagFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: {
    query: response.keyword
  }
});

const fetchFunction = (mainArea: server.dto.MainAreas) => {
  return (dto: server.dto.PaginatedTagInstruction) => {
    return window.CoreApi.Tag.Paginated(dto, mainArea);
  };
};

const ListTagApp = () => {
  const viewModel = useLoaderData<server.viewmodel.TagListFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ListTemplate
        title={RESX.Tag.Tags}
        // Filter set is not used for tag list
        filterSet="unknown"
        defaultFilters={viewModel.defaultFilters}
        initialInstruction={viewModel.initialInstruction}
        fetchFunction={fetchFunction(viewModel.mainArea)}
        getId={item => item.tagId}
        layout={{
          type: "table",
          hideHeader: true,
          columns: [{
            key: "name",
            header: "",
            render: item => <div>
              <div>
                <a href={routes.tag_Detail(item.tagId).absolute} className="table-main-link">{item.title}</a>
              </div>
              <div>
                {formatMainAreaItemWithCount(item.withTag, viewModel.mainArea)}
              </div>
            </div>,
            size: "1fr"
          }, {
            key: "tag",
            className: "s1_cell_financialamount",
            header: "",
            render: item => <Tag
              color={item.hexColor}
              label={item.code}
              title={item.code}
            />,
            size: "auto"
          }],
        }}
        filters={<>
          <KeywordFilter
            placeholder={RESX.GeneralLabels.Search}
          />
        </>}
        functions={{
          mapResponseToFilterValues,
          mapFilterValuesToInstruction,
        }}
        onNew={() => window.location.href = routes.tag_New(viewModel.mainArea).absolute}
      />
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout >;
};

export default ListTagApp;
